import React from 'react';
import { IconFill, IconOutline } from '@ant-design/icons-react-native';
import type { TDocumentsTabBarIconProps } from '../../types';

export const DocumentsTabBarIcon = ({ focused, size, color }: TDocumentsTabBarIconProps) => {
    if (focused) {
        return <IconFill name="file-text" size={size} color={color} />;
    }
    return <IconOutline name="file-text" size={size} color={color} />;
};
